import "core-js/modules/es.array.find.js";
import { useChannels } from './use-channels';
export function useNotificationChannel() {
  var channels = useChannels();
  return channels.find(function (ch) {
    return ch.enabled;
  });
}